import { DirectiveBinding } from 'vue';

export default {
  mounted(el: HTMLImageElement, binding: DirectiveBinding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.src = binding.value;
          observer.unobserve(el);
          el.classList.add('loaded');
        }
      });
    });
    observer.observe(el);
  }
};
